module.exports = __webpack_public_path__ + "img/xls.f725ed9f.svg";